import { useState } from 'react'
import PageDefault from 'components/PageDefault'
import { Col, Row, Button, Modal, Spinner } from 'react-bootstrap'
import actionPaymentService from 'services/payment.service'
import extractFormData from 'utils/extractFormatData'
import NewTable, { TableBodyData, TableHeaderColumn } from 'components/NewTable'
import NewForm from 'components/NewForm'
import Icon from 'components/Icon'
import { makeid } from 'utils/random'

export default function PaymentMethod() {
  const [key, setKey] = useState<any>(makeid(5))
  const [showModal, setShowModal] = useState<boolean>(false)
  const [data, setData] = useState<any>({})
  const [isSaving, setIsSaving] = useState<boolean>(false)

  function handleClose() {
    setShowModal(false)
  }

  const handleSubmit = async () => {
    setIsSaving(true)
    let formData = new FormData()
    extractFormData(data, formData)

    var response;
    if (data.id)
      response = actionPaymentService.update(data.id, formData)
    else
      response = actionPaymentService.store(formData)

    response
      .then(() => {
        reload()
        handleClose()
      })
      .finally(() => setIsSaving(false))
  }

  const handleUpdate = (id: number) => {
    actionPaymentService.show(id)
      .then((data) => {
        const {id, name} = data
        setData({...data, ...{id, name}})
        setShowModal(true)
      })
  }

  const reload = () => {
    setKey(makeid(5))
  }

  return (
    <PageDefault title="Tipo de Pagamento">
      <PageDefault.Title>Tipo de Pagamento</PageDefault.Title>
      <PageDefault.Content>
        <Row className="mt-3 mb-3">
          <Col>
            <Button
              onClick={() => {
                setShowModal(true)
              }}
            >
              Criar Tipo de Pagamento
            </Button>
          </Col>
        </Row>
        <NewTable>
          <TableHeaderColumn dataField="id">ID</TableHeaderColumn>
          <TableHeaderColumn dataField="name">Tipo de Pagamento</TableHeaderColumn>
          <TableHeaderColumn dataField="id|" isAction mask={(v:any[])=>{
            const [id] = v;
            return (
              <>
                <Button size="sm" style={{margin:"0px 1px"}} onClick={() => handleUpdate(id)}><Icon name="edit"/></Button>
              </>
            );
          }}>Ação</TableHeaderColumn>
          <TableBodyData
            key={key}
            request={actionPaymentService} 
            filterDefaut={{
              order_column: '!id'
            }}
          />
        </NewTable>
      </PageDefault.Content>
      <Modal
        centered
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <NewForm title='Criar Tipo de Pagamento'>
            <NewForm.Input title="Nome" md="12" name="name" state={{model: data, setModel: setData}}/>
          </NewForm>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={isSaving} variant="secondary" onClick={handleClose}>
            Cancelar {isSaving ? <Spinner animation="border" size="sm" /> : (<></>)}
          </Button>
          <Button disabled={isSaving} variant="primary" onClick={() => handleSubmit()}>
            Salvar {isSaving ? <Spinner animation="border" size="sm" /> : (<></>)}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <SweetAlert2 {...swalProps} /> */}
    </PageDefault>
  )
}